
import UserNameSvg from "./UserNameSvg.vue"

export default {
    components: {UserNameSvg}
}
